export const translations = {
  es: {
    reservation: {
      selectDateAlert: "Selecciona una fecha antes de continuar.",
      completeDataAlert: "Completa tus datos para continuar.",
      bookingError: "Error al crear la reserva",
      paymentError: "Error al iniciar el pago con Onvo",
      redirectError: "No se recibió redirect_url de Onvo",
      paymentProcessingError: "Error al procesar el pago",
      serviceNotFound: "Servicio no encontrado",
      serviceUnavailable: "El servicio que buscas no está disponible en este momento.",
      backToHome: "Volver al inicio",
      home: "Inicio",
      services: "Servicios",
      serviceDescription: "Descripción del servicio",
      aboutOperator: "Sobre el operador",
      active: "Activo",
      bookNow: "Reservar ahora",
      pricePerPerson: "Precio por persona",
      duration: "Duración",
      selectDate: "Seleccione una fecha",
      noAvailability: "No hay disponibilidad para este servicio en este momento.",
      availableSlots: "cupos disponibles",
      continueBooking: "Continuar con la reserva",
      bookingDetails: "Detalles de la reserva",
      selectedDate: "Fecha seleccionada",
      numberOfParticipants: "Número de participantes",
      maximum: "Máximo",
      total: "Total",
      continuePersonalData: "Continuar con los datos personales",
      goBack: "Volver atrás",
      clientData: "Datos del cliente",
      fullName: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      country: "País",
      costaRica: "Costa Rica",
      usa: "Estados Unidos",
      canada: "Canadá",
      spain: "España",
      other: "Otro",
      totalReference: "Total (referencia)",
      proceedToPayment: "Proceder al pago",
      paymentMethod: "Método de pago",
      securePayment: "Pago seguro con Onvo",
      paymentRedirect: "Serás redirigido a la plataforma de Onvo para completar el pago (tarjeta o SINPE). Al finalizar, volverás a nuestro sitio automáticamente.",
      currency: "Moneda",
      colones: "Colones (CRC)",
      dollars: "Dólares (USD)",
      method: "Método",
      card: "Tarjeta o Sinpe",
      sinpe: "SINPE / Transferencia bancaria",
      bookingSummary: "Resumen de la reserva",
      schedule: "Horario",
      participants: "Participantes",
      redirecting: "Redirigiendo…",
      payNow: "Pagar ahora con Onvo",
      verifyEmail: "Verificar Email",
      verificationSent: "Código de verificación enviado",
      checkEmail: "Hemos enviado un código de verificación a",
      verificationCode: "Código de Verificación",
      enterCode: "Ingresa el código de verificación",
      verifying: "Verificando...",
      verifyAndPay: "Verificar y Pagar",
      resendCode: "Reenviar Código",
      verificationCodeRequired: "Por favor ingresa el código de verificación",
      verificationFailed: "Código de verificación incorrecto",
      resendFailed: "Error al reenviar el código",
      codeResent: "Código reenviado correctamente",
      resendError: "Error al reenviar el código",
      creatingBooking: "Creando reserva...",
      createBooking: "Crea la reserva"

    }
  },
  en: {
    reservation: {
      selectDateAlert: "Please select a date before continuing.",
      completeDataAlert: "Please complete your information to continue.",
      bookingError: "Error creating booking",
      paymentError: "Error initiating payment with Onvo",
      redirectError: "No redirect_url received from Onvo",
      paymentProcessingError: "Error processing payment",
      serviceNotFound: "Service not found",
      serviceUnavailable: "The service you are looking for is not available at this time.",
      backToHome: "Back to home",
      home: "Home",
      services: "Services",
      serviceDescription: "Service description",
      aboutOperator: "About the operator",
      active: "Active",
      bookNow: "Book now",
      pricePerPerson: "Price per person",
      duration: "Duration",
      selectDate: "Select a date",
      noAvailability: "There is no availability for this service at this time.",
      availableSlots: "available slots",
      continueBooking: "Continue with booking",
      bookingDetails: "Booking details",
      selectedDate: "Selected date",
      numberOfParticipants: "Number of participants",
      maximum: "Maximum",
      total: "Total",
      continuePersonalData: "Continue with personal data",
      goBack: "Go back",
      clientData: "Client data",
      fullName: "Full name",
      email: "Email",
      phone: "Phone",
      country: "Country",
      costaRica: "Costa Rica",
      usa: "United States",
      canada: "Canada",
      spain: "Spain",
      other: "Other",
      totalReference: "Total (reference)",
      proceedToPayment: "Proceed to payment",
      paymentMethod: "Payment method",
      securePayment: "Secure payment with Onvo",
      paymentRedirect: "You will be redirected to the Onvo platform to complete the payment (card or SINPE). Upon completion, you will return to our site automatically.",
      currency: "Currency",
      colones: "Colones (CRC)",
      dollars: "Dollars (USD)",
      method: "Method",
      card: "Card (via Onvo)",
      sinpe: "SINPE / Bank transfer",
      bookingSummary: "Booking summary",
      schedule: "Schedule",
      participants: "Participants",
      redirecting: "Redirecting…",
      payNow: "Pay now with Onvo",
     verifyEmail: "Verify Email",
      verificationSent: "Verification code sent",
      checkEmail: "We've sent a verification code to",
      verificationCode: "Verification Code",
      enterCode: "Enter verification code",
      verifying: "Verifying...",
      verifyAndPay: "Verify and Pay",
      resendCode: "Resend Code",
      verificationCodeRequired: "Please enter the verification code",
      verificationFailed: "Incorrect verification code",
      resendFailed: "Failed to resend code",
      codeResent: "Code resent successfully",
      resendError: "Error resending code",
      creatingBooking: "Creating booking...",
      createBooking: "Create the booking"
    }
  }
};